module.exports = function () {
    throw new Error("Not implemented.");
};